import React from 'react';
import { TextField } from 'framework/ui/field';

const VacancyPublicationField = (props: any) => {
  const { value } = props;

  return <TextField value={value} />;
};

export default VacancyPublicationField;
